import { useState } from "react";
import { useData } from "@/hooks/useData";
import { Pollutant } from "@/types/pollutant/pollutant.types";
import { usePollutantFilters } from "./usePollutantFilters";

export const usePollutantTable = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [nameFilters, setNameFilters] = useState<string[]>([]);

    const {
        data: pollutants,
        loading,
        refetch,
    } = useData<Pollutant>({
        collectionName: "setup_pollutants",
    });

    const { filteredPollutants, getUniqueOptions } = usePollutantFilters({
        pollutants,
        searchTerm,
        nameFilters,
    });

    const clearFilters = () => {
        setSearchTerm("");
        setNameFilters([]);
    };

    const nameOptions = getUniqueOptions("name");

    return {
        pollutants,
        filteredPollutants,
        loading,
        refetch,
        searchTerm,
        setSearchTerm,
        nameFilters,
        setNameFilters,
        clearFilters,
        nameOptions,
    };
}; 